import { AEntity } from "../a-entity";
import { Right } from "./right";
import { IMenuStructure } from "./i-menu-structure";

export class Menu extends AEntity implements IMenuStructure {
    route: string;
    translation: string;
    rank: number;
    parentMenuId: number;
    restrictionExplanation: string;

    structurePath: string;
    isOwned: boolean;

    private _subMenus: Menu[];
    get subMenus(): Menu[] {
        return this._subMenus;
    }
    set subMenus(subMenus: Menu[]) {
        this._subMenus = this.convertArray(Menu, subMenus).sort((a, b): number => {
            if (a.rank < b.rank) return -1;
            else if (a.rank > b.rank) return 1;
            else if (a.route < b.route) return -1;
            else if (a.route > b.route) return 1;
            else return 0;
        });
    }

    private _rights: Right[];
    get rights(): Right[] {
        return this._rights;
    }
    set rights(rights: Right[]) {
        this._rights = this.convertArray(Right, rights).sort((a, b): number => {
            if (a.rank < b.rank) return -1;
            else if (a.rank > b.rank) return 1;
            else if (a.code < b.code) return -1;
            else if (a.code > b.code) return 1;
            else return 0;
        });
    }

    private compareFn = (a: IMenuStructure, b: IMenuStructure) => { return (a.rank < b.rank) ? -1 : ((a.rank > b.rank) ? 1 : 0); };
    get children(): IMenuStructure[] { return (this.subMenus && this.subMenus.length ? this.subMenus.sort(this.compareFn) : this.rights.sort(this.compareFn)); }
}
